export default "__VITE_ASSET__Uf6Vk5dD__"